import MobileBackBtn from '../MobileBackBtn'
import { StyledScreenWrapper } from '../styles'
import LanguageSelector from 'components/LanguageSelector'

interface ScreenLanguageProps {
  handleScreenDefault: () => void
  handleCloseMenu: () => void
}

function ScreenLanguage(props: ScreenLanguageProps) {
  return (
    <StyledScreenWrapper>
      <MobileBackBtn
        handleClick={props.handleScreenDefault}
        text="Select Language"
      />
      <div onClick={props.handleCloseMenu}>
        <LanguageSelector isMobileMode />
      </div>
    </StyledScreenWrapper>
  )
}

export default ScreenLanguage
